import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppSettings } from '../shared/AppSettings';
import { tWhseModel } from '../models/tWhseModel';
import { tPresMediConvModel } from '../models/tMediConvModel';
import { tPrescriptionCopyLineModel, tPrescriptionLineModel, tPrescriptionLineModel_PrintPrescription, tPrescriptionLineModel_withStock, tPrescriptionLineModel_withStock_withRemark } from '../models/tPrescriptionLineModel';
import { tPrescriptionHeadModel, tPrescriptionHeadModelWithPatientBPInfo,tPrescriptionDirectionsModel,tCookingMethod, tPrescriptionCopyHeadModel, tPrescriptionPickModelWithList, tPrescriptionHeadModelWithPatientBPInfoV2 } from '../models/tPrescriptionHeadModel';
import { tConsultHeadModel } from '../models/tConsultHeadModel';
import { text } from '@angular/core/src/render3';
import { tMedicineModel } from '../Models/tMedicineModel';
import { tPickModel } from '../models/tPickModel';



@Injectable({
    providedIn: 'root'
})

export class tPrescriptionService {

    constructor(private http: HttpClient) { }

    baseurl: string = AppSettings.BaseURI;

    readonly pathName = '/tPrescriptionsModels';


    getBillPresCount(shopID: string, clthConsultNumber: string) {
        // tslint:disable-next-line:max-line-length
        return this.http.get<number>(this.baseurl + this.pathName + '/getBillPresCount/' + shopID + '/' + clthConsultNumber);
    }


    getAllHeadbyDate(shopID: string, ArrDate: string) {
        // tslint:disable-next-line:max-line-length
        return this.http.get<tPrescriptionHeadModelWithPatientBPInfo[]>(this.baseurl + this.pathName + '/getAllHeadbyDate/' + shopID + '/' + ArrDate);
    }

    getAllHeadbyDateV2(shopID: string, ArrDate: string) {
        // tslint:disable-next-line:max-line-length
        return this.http.get<tPrescriptionHeadModelWithPatientBPInfoV2[]>(this.baseurl + this.pathName + '/getAllHeadbyDate/' + shopID + '/' + ArrDate);
    }

    getAllHeadbyDateForPickList(shopID: string, ArrDate: string) {
        // tslint:disable-next-line:max-line-length
        return this.http.get<tPrescriptionPickModelWithList[]>(this.baseurl + this.pathName + '/getAllHeadbyDate/' + shopID + '/' + ArrDate);
    }

    getAllHeadbyPatient(shopID: string, patientID: string) {
        // tslint:disable-next-line:max-line-length
        return this.http.get<tPrescriptionHeadModelWithPatientBPInfo[]>(this.baseurl + this.pathName + '/getAllHeadbyPatient/' + shopID + '/' + patientID);
    }
    getAllHeadbyCopy(shopID: string,method:string) {
        // tslint:disable-next-line:max-line-length
        return this.http.get<tPrescriptionCopyHeadModel[]>(this.baseurl + this.pathName + '/getAllHeadbyCopy/' + shopID+'/'+method);
    }
    newHead(data: tConsultHeadModel) {
        return this.http.post(this.baseurl + this.pathName + '/Formatted/NewPres/', data);
    }
    updatePrescriptionStatus_pick(data: tPrescriptionHeadModel) {
        return this.http.post(this.baseurl + this.pathName + '/pickPrescription/', data);
    }
    getPickData(prescriptionNumber:string) {
        return this.http.get<any[]>(this.baseurl + this.pathName + '/getPick/' + prescriptionNumber);
    }
    deletePickData(id:number) {
        return this.http.delete(this.baseurl + this.pathName + '/deletePick/' + id);
    }
    getHead(shopID: string, prescriptionNumber: string) {
        return this.http.get<tPrescriptionHeadModel>(this.baseurl + this.pathName + '/GetSavedHead/' + shopID + '/' + prescriptionNumber);
    }
    getCopyHead(shopID: string, prescriptionNumber: string) {
        return this.http.get<tPrescriptionCopyHeadModel>(this.baseurl + this.pathName + '/GetSavedCopyHead/' + shopID + '/' + prescriptionNumber);
    }
    getLine(shopID: string, prescriptionNumber: string) {
        return this.http.get<tPrescriptionLineModel_withStock[]>(this.baseurl + this.pathName + '/GetSavedLine/'
        + shopID + '/' + prescriptionNumber);
    }
    getCopyLine(shopID: string, prescriptionNumber: string) {
        return this.http.get<tPrescriptionLineModel_withStock[]>(this.baseurl + this.pathName + '/GetSavedCopyLine/'
        + shopID + '/' + prescriptionNumber);
    }
    getCopyLineCopy(shopID: string, prescriptionNumber: string) {
        return this.http.get<tPrescriptionLineModel_withStock[]>(this.baseurl + this.pathName + '/GetSavedCopyLineCopy/'
        + shopID + '/' + prescriptionNumber);
    }
    CheckCopyLine(shopID: string, prescriptionNumber: string) {
        return this.http.get<tMedicineModel[]>(this.baseurl + this.pathName + '/CheckSavedCopyLine/'
        + shopID + '/' + prescriptionNumber);
    }
    CheckCopyLineCopy(shopID: string, prescriptionNumber: string) {
        return this.http.get<tMedicineModel[]>(this.baseurl + this.pathName + '/CheckSavedCopyLineCopy/'
        + shopID + '/' + prescriptionNumber);
    }
    getPrintLine(shopID: string, prescriptionNumber: string) {
        return this.http.get<tPrescriptionLineModel_withStock_withRemark[]>(this.baseurl + this.pathName + '/GetPrintSavedLine/'
        + shopID + '/' + prescriptionNumber);
    }
    getPrintCopyLine(shopID: string, prescriptionNumber: string) {
        return this.http.get<tPrescriptionLineModel_withStock_withRemark[]>(this.baseurl + this.pathName + '/GetPrintSavedCopyLine/'
        + shopID + '/' + prescriptionNumber);
    }
    getPrintLine2(shopID: string, prescriptionNumber: string) {
        return this.http.get<tPrescriptionLineModel_PrintPrescription[]>(this.baseurl + this.pathName + '/GetPrintSavedLine2/'
        + shopID + '/' + prescriptionNumber);
    }



    getStockOnHand(shopID: string, itemID: string) {
        return this.http.get<number>(this.baseurl + this.pathName + '/StockOnHand/' + shopID + '/' + itemID);
    }

    savePres(data: any){
        return this.http.post(this.baseurl + this.pathName + '/Formatted/SavePres/', data);
    }
    savePick(data: tPickModel[]){
        return this.http.post(this.baseurl + this.pathName + '/Formatted/SavePick/', data);
    }
    savePresCopy(data: any){
        return this.http.post(this.baseurl + this.pathName + '/Formatted/SavePresCopy/', data);
    }
    deleteData(data: tPrescriptionHeadModelWithPatientBPInfo) {
        return this.http.delete(this.baseurl + this.pathName + '/' + data.shopID + '/'
        + data.clthConsultNumber + '/' + data.prescriptionNumber);
    }
    deleteCopyPres(copyPresNum:string){
        return this.http.delete(this.baseurl + this.pathName + '/deleteCopyPres/'
        + copyPresNum);
    }
    getLatestSellingPrice(shopID: string, itemID: string) {
        return this.http.get<number>(this.baseurl + this.pathName + '/GetLatestSellingPrice/' + shopID + '/' + itemID);
    }



    getRefConc(shopID: string, itemID: string) {
        return this.http.get<string>(this.baseurl + this.pathName + '/RefConc/' + shopID + '/' + itemID);
    }

    GettPrescriptionDirections(){
        return this.http.get<tPrescriptionDirectionsModel[]>(this.baseurl + this.pathName + '/GettPrescriptionDirections');
    }
    GettCookingMethod(){
        return this.http.get<tCookingMethod[]>(this.baseurl + this.pathName + '/GettCookingMethod');
    }
    GetPrescNumByConsultNum(consultNumber:string){
        return this.http.get<GetPrescNumByConsultNumInterface[]>(this.baseurl + this.pathName + '/prescsNumByConsultNum/'+consultNumber);
    }


    checkBillPayPres(prescriptionNumber: string) {
        return this.http.post(this.baseurl + this.pathName + '/checkPresInBillPay/' + prescriptionNumber,prescriptionNumber);
    }


    updateCopyPres(data: any){
        return this.http.post(this.baseurl + this.pathName + '/Formatted/updateCopyPres/', data);
    }

    getDrugLabelPrint(prescriptionNumber:string){
      return this.http.get<any>(this.baseurl + this.pathName + `/prescriptionLabelPrint/${prescriptionNumber}/`);

    }
}

export class GetPrescNumByConsultNumInterface{
    prescNumber:string;
}
